var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgAssets = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2 0C0.895431 0 0 0.89543 0 2V13C0 14.1046 0.89543 15 2 15H13C14.1046 15 15 14.1046 15 13V2C15 0.895431 14.1046 0 13 0H2ZM13 2H2L2 13H13V2Z",
    fill: "#DADDDE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2 19C0.895431 19 0 19.8954 0 21V32C0 33.1046 0.89543 34 2 34H13C14.1046 34 15 33.1046 15 32V21C15 19.8954 14.1046 19 13 19H2ZM13 21H2L2 32H13V21Z",
    fill: "#DADDDE"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19 2C19 0.89543 19.8954 0 21 0H32C33.1046 0 34 0.895431 34 2V13C34 14.1046 33.1046 15 32 15H21C19.8954 15 19 14.1046 19 13V2ZM21 2H32V13H21V2Z",
    fill: "#DADDDE"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M26.5 19.5C27.0523 19.5 27.5 19.9477 27.5 20.5V25.5H32.5C33.0523 25.5 33.5 25.9477 33.5 26.5C33.5 27.0523 33.0523 27.5 32.5 27.5H27.5V32.5C27.5 33.0523 27.0523 33.5 26.5 33.5C25.9477 33.5 25.5 33.0523 25.5 32.5V27.5H20.5C19.9477 27.5 19.5 27.0523 19.5 26.5C19.5 25.9477 19.9477 25.5 20.5 25.5H25.5V20.5C25.5 19.9477 25.9477 19.5 26.5 19.5Z",
    fill: "#DADDDE"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgAssets);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/assets.104dce8a34a507ba11f218a86bebb6cb.svg";